import { NgModule } from '@angular/core';
import { NgxTabFocusDirective } from './directive';



@NgModule({
  declarations: [NgxTabFocusDirective],
  imports: [],
  exports: [NgxTabFocusDirective]
})
export class NgxTabFocusModule { }
